/* eslint-disable @typescript-eslint/ban-types*/
/* eslint-disable no-extra-boolean-cast*/
/* eslint-disable @typescript-eslint/no-explicit-any*/
import { find, get, toNumber, trim } from 'lodash';
import numeral from 'numeral';
import { NumberFormatValues } from 'react-number-format';
import * as XLSX from 'xlsx';
import { WorkSheet } from 'xlsx';
import { store } from 'app/store';
import { ActionGetDetailNoti } from 'redux/thongBao/action';
import * as yup from 'yup';
import { MESSAGE_ERR, sourceApp, versionApp } from './constants';
import parse_query_string from './parse_query_string';
import { setStorageData, STORAGE_KEY } from './storage';
import { REACT_APP_URL_SSO } from './env';

export const pageItemsDefault = '10';

/**
 * @param error object error
 * @param path get error for path, default: message
 */
export const getMessageError = (error: unknown, path = 'message'): string => {
  return get(error, path, MESSAGE_ERR);
};

export const capitalizeString = (str: string): string => {
  if (!str) return '';
  return `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`;
};

export const formatterNumber = (num?: string | number): string => {
  if (!num) return '';
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// export const numberFormat = (num?: number | string): string => {
//   if (!num) return '0';

//   let number = 0;
//   if (typeof num === 'number') {
//     number = num;
//   } else if (typeof num === 'string') {
//     number = Number.parseFloat(num);
//   } else {
//     return '0';
//   }

//   if (Number.isNaN(number)) return '0';

//   const numberFormat = new Intl.NumberFormat(); //default: English, vi-VN: Vietnamese
//   return numberFormat.format(number);
// };

export function formatNumber(value: number): string {
  let str = numeral(value).format('0,0');
  const newchar = '.';
  str = str.split(',').join(newchar);
  return str;
}

export function getValueOfNumberFormat(value: string): string {
  if (isNaN(parseFloat(value))) {
    return value;
  } else {
    const valueNum = numeral(value).value()
    return !!valueNum ? valueNum?.toString() : '0'
  }
}

export function numberFormatDecimal(value: string): string {
  return numeral(toNumber(value)).format('0.0,0');
}

export function numberFormat(value: string | number): string {
  if (!value) return '0';

  return numeral(toNumber(value)).format('0,0');
}

export const file2Base64 = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result?.toString() || '');
    reader.onerror = error => reject(error);
  })
}

export function handleErrorMessage(errors: yup.ValidationError[], errorName: string): string {
  return get(
    find(errors, (item: yup.ValidationError): boolean => item.path === errorName),
    'message',
    '',
  );
}

export const onChangeTextInputTypeJSONValue = (setValueFunction: Function) => (
  event: React.ChangeEvent<HTMLInputElement>,
): void => {
  const value = event.currentTarget.value;
  setValueFunction(JSON.parse(value));
};

export const onChangeTextInputValue = (setValueFunction: Function) => (
  event: React.ChangeEvent<HTMLInputElement>,
): void => {
  const value = event.currentTarget.value;
  if(value[0] === ' '){
    setValueFunction(trim(value));
  } else setValueFunction(value);
};

export const onChangeTextInputCleanValue = (setValueFunction: Function) => (
  event: React.ChangeEvent<HTMLInputElement>,
): void => {
  const value = event.currentTarget.value;
  if(value[0] === ' '){
    setValueFunction(trim(cleanAccents(value)));
  } else setValueFunction(cleanAccents(value));
};

export const onChangeTextInputObjValue = (setValueFunction: Function) => (
  event: React.ChangeEvent<HTMLInputElement>,
): void => {
  const value = JSON.parse(event.currentTarget.value);
  setValueFunction(value);
};

export const onChangeTextInputNumberValue = (setValueFunction: Function) => (
  event: React.ChangeEvent<HTMLInputElement>,
): void => {
  const value = event.currentTarget.value;
  setValueFunction(getValueOfNumberFormat(value));
};

export const onChangeTextInputTrimValue = (setValueFunction: Function) => (
  event: React.ChangeEvent<HTMLInputElement>,
): void => {
  const value = event.currentTarget.value;
  setValueFunction(trim(value));
};

export const onChangeTextInputTrimValueForm = (setValueFunction: Function, callback?: Function, key?: string) => (
  event: React.ChangeEvent<HTMLInputElement>,
): void => {
  const value = event.currentTarget.value;
  setValueFunction(trim(value));
  callback?.(key, value)
};

export const onChangeCheckedValue = (setValueFunction: Function) => (
  event: React.FormEvent<HTMLInputElement>,
): void => {
  const checked = event.currentTarget.checked;
  setValueFunction(checked);
};


export const onChangeTextInputNumberFormat = (setValueFunction: Function) => (values: NumberFormatValues): void => {
  setValueFunction(values.floatValue || '');
};

export const cleanAccents = (str: string): string => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');
  // Combining Diacritical Marks
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // huyền, sắc, hỏi, ngã, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // mũ â (ê), mũ ă, mũ ơ (ư)

  return str;
};

export function validateXlsxNhapDon(workSheet: WorkSheet): boolean {
  return (
    trim(get(workSheet, 'A1.v')) === 'stt' &&
    trim(get(workSheet, 'B1.v')) === 'MA_PHIEUGUI' &&
    trim(get(workSheet, 'C1.v')) === 'TEN_NGUOI_NHAN (*)' &&
    trim(get(workSheet, 'D1.v')) === 'DIEN_THOAI_KHNHAN (*)' &&
    trim(get(workSheet, 'E1.v')) === 'DIACHI_KHNHAN (*)' &&
    trim(get(workSheet, 'F1.v')) === 'TINH_DEN' &&
    trim(get(workSheet, 'G1.v')) === 'QUAN_HUYEN_DEN' &&
    trim(get(workSheet, 'H1.v')) === 'PHUONG_XA_DEN' &&
    trim(get(workSheet, 'I1.v')) === 'TEN_HANG_HOA (*)' &&
    trim(get(workSheet, 'J1.v')) === 'Số lượng' &&
    trim(get(workSheet, 'K1.v')) === 'TRONG_LUONG (GRAM)  (*)' &&
    trim(get(workSheet, 'L1.v')) === 'Giá trị hàng' &&
    trim(get(workSheet, 'M1.v')) === 'Thu Hộ' &&
    trim(get(workSheet, 'N1.v')) === 'Dịch vụ' &&
    trim(get(workSheet, 'O1.v')) === 'Dài (Cm)' &&
    trim(get(workSheet, 'P1.v')) === 'Rộng (Cm)' &&
    trim(get(workSheet, 'Q1.v')) === 'Cao(Cm)' &&
    trim(get(workSheet, 'R1.v')) === 'DICH_VU_DAC_BIET' &&
    trim(get(workSheet, 'S1.v')) === 'Người trả cước' &&
    trim(get(workSheet, 'T1.v')) === 'Ghi chú' &&
    trim(get(workSheet, 'U1.v')) === 'Thời gian giao'
  );
}

export function transformXlsxRowToTaoDonItem(row: any, index: number): any {
  const stt = get(row, 'stt', '');
  const maPhieuGui = get(row, 'MA_PHIEUGUI', '');
  const tenNguoiNhan = get(row, 'TEN_NGUOI_NHAN (*)', '');
  const soDienThoai = get(row, 'DIEN_THOAI_KHNHAN (*)', '');
  const diaChiNhan = get(row, 'DIACHI_KHNHAN (*)', '');
  const tinhThanh = get(row, 'TINH_DEN', '');
  const quanHuyen = get(row, 'QUAN_HUYEN_DEN ', '');
  const phuongXa = get(row, 'PHUONG_XA_DEN', '');
  const tenHang = get(row, 'TEN_HANG_HOA (*)', '');
  const soLuong = get(row, 'Số lượng', '');
  const trongLuong = get(row, 'TRONG_LUONG (GRAM) (*)', '');
  const giaTri = get(row, 'Giá trị hàng', '');
  const thuHo = get(row, 'Thu Hộ', '');
  const dichVu = get(row, 'Dịch vụ', '');
  const dai = get(row, 'Dài (Cm)', '');
  const rong = get(row, 'Rộng (Cm)', '');
  const cao = get(row, 'Cao(Cm)', '');
  const dvDacbiet = get(row, 'DICH_VU_DAC_BIET', '');
  const nguoiTraCuoc = get(row, 'Người trả cước', '');
  const ghiChu = get(row, 'Ghi chú', '');
  const thoiGianGiao = get(row, 'Thời gian giao', '');

  return {
    stt,
    maPhieuGui,
    tenNguoiNhan,
    soDienThoai,
    diaChiNhan,
    tinhThanh,
    quanHuyen,
    phuongXa,
    tenHang,
    soLuong,
    trongLuong,
    giaTri,
    thuHo,
    dichVu,
    dai,
    rong,
    cao,
    dvDacbiet,
    nguoiTraCuoc,
    ghiChu,
    thoiGianGiao,
  };
}

export const ExportExcel = (data: unknown[], fileName: string, nameSheet: string) => {
  try {
    const dotFile = '.xlsx';
    if (typeof data === 'undefined' || typeof fileName === 'undefined' || typeof nameSheet === 'undefined') {
      alert('Phải nhận đủ 3 tham số: dữ liệu, tên file, tên sheet');
      return;
    }

    if (typeof data !== 'object') {
      alert('Dữ liệu đầu vào phải là một array hoặc object');
      return;
    }

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, nameSheet);

    XLSX.writeFile(wb, fileName + dotFile);
  } catch (error) {
    // alert(JSON.stringify(error.message));
  }
};

export const onDownloadTemplateFile = (url: string, fileName?: string): void => {
  try {
    const nameFile = fileName ? fileName : url.split('/').pop() || '';
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.setAttribute('download', nameFile);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
};

export function getPageItems(): string {
  return parse_query_string('pageitems', pageItemsDefault);
}

export function getFullAddress(
  detailAddress?: string,
  hamletName?: string,
  textWard?: string,
  textDistrict?: string,
  textProvince?: string,
): string {
  const fullAddress = `${!!detailAddress ? detailAddress + ', ' : ''}${!!hamletName ? hamletName + ', ' : ''}${!!textWard ? textWard + ', ' : ''
    }${!!textDistrict ? textDistrict + ', ' : ''}${textProvince}`;
  return fullAddress;
}

export function onLogout(): void {
  setStorageData(STORAGE_KEY.ACCESS_TOKEN, null);
  setStorageData(STORAGE_KEY.USER_INFO, null);
  // const auth = getAuth();
  // signOut(auth).then(() => {
  //   // Sign-out successful.
  // }).catch((error) => {
  //   // An error happened.
  // });
  // window.location.reload()
  window.location.href = `${REACT_APP_URL_SSO}/logout?returnUrl=${encodeURIComponent(window.location.origin)}&version=${versionApp}&source=${sourceApp}`;
}

export function onGetDetailAction(itemUpdate: ListNotiITF) {
  store.dispatch(ActionGetDetailNoti(itemUpdate?.id ,{
    onSuccess: (data: ListNotiITF) => {
      onActionNoti(data?.map_ext);
    }
  }))
}

export function onActionNoti(action?: ActionNotiType) {
  if(action?.ActionType?.toLowerCase?.() === "link" && !!action?.Action) {
    window.location.replace('/'+action?.Action);
  }
}